const tags = (filters) =>
  (filters.availableTags || []).map((tag) => ({
    id: tag.uuid,
    title: tag.name,
    icon: 'label',
    payload: {
      type_key: 'assetTagIds',
      object: {
        id: tag.id,
      },
    },
  }))

export default tags
